// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ol-target-element {\n    align-self: stretch !important;\n}", "",{"version":3,"sources":["webpack://./src/platform/pixelmotion/style/srp.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC","sourcesContent":[".ol-target-element {\n    align-self: stretch !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
